export default {"src":"/_next/static/media/microchip_64.cb5ad395.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};